import { render } from "./SendTask.vue?vue&type=template&id=ad084b48"
import script from "./SendTask.vue?vue&type=script&lang=js"
export * from "./SendTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__